export default "__VITE_ASSET__a019d5c3__"